// removed by extract-text-webpack-plugin
module.exports = {"form":"login__form__1yyfJ","title":"login__title__1Lgzx","h1":"login__h1__OvcuL login__title__1Lgzx","input":"login__input__1WTwx","button":"login__button__WUuUw login__title__1Lgzx","error":"login__error__382o4"};


//////////////////
// WEBPACK FOOTER
// ./src/login/login.scss
// module id = 57
// module chunks = 0